import { render, staticRenderFns } from "./PagesAdmin.vue?vue&type=template&id=6c4ba93a&"
import script from "./PagesAdmin.vue?vue&type=script&lang=js&"
export * from "./PagesAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports